import produce from "immer";
import React, { FC } from "react";
import { useDispatch, useSelector } from "react-redux";
import { uuid } from "uuidv4";
import { Element } from "../../../../models/elementModel";
import { TableRowModel } from "../../../../models/tableRowModel";
import {
  getAllElements,
  getElementById,
} from "../../../../selectors/elementListSelector";
import TabelCellElement from "./tableCellElement";
import elementService from "../../../../services/elementService";
import {
  copyTableCellElements,
  startCopyRow,
  startEditElement,
} from "../../../../actions/elementListAction";
import { removeElementList } from "../../../../actions/dustbinAction";
import { getSession } from "../../../../selectors/appSelectors";
import { SystemTypes } from "../../../../utils/constants";

export interface TableRowElementProps {
  index: number;
  row: TableRowModel;
  element: Element;
  isPreview?: boolean;
}

const TableRowElement: FC<TableRowElementProps> = ({ index, row, element, isPreview = false }) => {
  const dispatch = useDispatch();
  const elementsState = useSelector(getAllElements);
  const elementById = useSelector(getElementById(element.id));
  const sessionState = useSelector(getSession);
  const deleteRowAction = async () => {
    let cellElementList: Element[] = [];

    for (let index = 0; index < row.cells.length; index++) {
      const element = row.cells[index];
      let cellElements = elementsState.present.filter((element) => {
        return element.cellId === row.cells[index].id;
      });
      cellElementList = cellElementList.concat(cellElements);
    }

    const newElement = produce(elementById, (draft: Element) => {
      draft.properties.rows.splice(index, 1);
    });
    dispatch(startEditElement(newElement));
    await elementService.deleteElements(cellElementList);
    dispatch(removeElementList(cellElementList));
  };

  const copyRowAction = async () => {
    dispatch(startCopyRow(element, row, index, isPreview));
  };

  return (
    <tr key={`${row.id}`} className={row.class}>
        {row.cells.map((cell) => {
          return (
            <TabelCellElement
              cell={cell}
              sectionId={element.sectionId}
              formId={element.formId}
              isPreview={isPreview}
              tableTheam={element.properties.tableTheme}
            />
          );
        })}
        {!isPreview && sessionState.selectedType === SystemTypes.ELEMENT &&
          sessionState.selectedElementId === element.id && (
            <td style={{borderBottom: element.properties.tableTheme === "table-borderless" || element.properties.tableTheme === undefined || element.properties.tableTheme === "" ? '0px' : '', borderTop: element.properties.tableTheme === "table-borderless" || element.properties.tableTheme === undefined || element.properties.tableTheme === "" ? '0px' : ''}}>
              <i
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  deleteRowAction();
                }}
                className="fa fa-trash-o"
                aria-hidden="true"
              ></i>
              <i
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  copyRowAction();
                }}
                className="fa fa-clone"
              ></i>
            </td>
          )}
      </tr>
  );
};

export default TableRowElement;
